// api.js

import axios from 'axios'
import { Response, queryParam } from './_model'
import { FileModel } from './misc'

const BASE_URL = process.env.REACT_APP_BASE_URL + '/settings'

export const settings_api = async (data: queryParam): Promise<SettingModel> => {
  return await axios.get(`${BASE_URL}?${data.queryKey[1] || ''}`)
}
export const update_setting_api = async (data: SettingModel) => {
  return await axios.put(`${BASE_URL}`, data)
}
export const create_onboarding_settings_api = async (
  data: OnboardingSettingsModel
) => {
  return await axios.post(`${BASE_URL}/onboarding`, data)
}

export const update_onboarding_settings_api = async (
  data: OnboardingSettingsModel
) => {
  return await axios.put(`${BASE_URL}/onboarding/${data.id}`, data)
}
export const onboarding_settings_api = async (
  data: queryParam
): Promise<Response<OnboardingSettingsModel[]>> => {
  return await axios.get(`${BASE_URL}/onboarding?${data.queryKey[1] || ''}`)
}
export const delete_onboarding_settings_api = async (data: string) => {
  return await axios.delete(`${BASE_URL}/onboarding/${data}`)
}

export const create_addition_field_api = async (data: AdditionalFieldsModel) =>
  axios.post(`${BASE_URL}/additional-field`, data)

export const update_addition_field_api = async (data: AdditionalFieldsModel) =>
  axios.put(`${BASE_URL}/additional-field/${data.id}`, data)

export const delete_addition_field_api = async (id: string | string[]) =>
  axios.delete(`${BASE_URL}/additional-field/${id}`)

export type SettingModel = {
  business_logo?: string
  business_name?: string
  business_email?: string
  business_phone?: string
  address?: string
  currency?: string
  default_rate?: number
  invoice_default_due_days?: number
  payment_instructions?: string
  default_billing_rate_type?: 'hourly' | 'flat'
  default_pay_period?: string
  primary_color?: string
  secondary_color?: string
  time_zone?: string
  use_clocking_time?: boolean
  invoice_template?: number
  use_live_location_for_clock_in?: boolean
  use_live_location_for_clock_out?: boolean
  payroll_template?: number
  tax_name?: string
  tax_rate?: number
  tax_inclusive?: boolean
  generate_invoice_without_clockout?: boolean
  generate_payroll_without_clockout?: boolean
  completed_guided_setup?: string
  file?: FileModel
  media?: any
  max_work_hours_before_break?: number
  break_hours?: number
  invoice_break?: boolean
  payroll_break?: boolean
  country?: string
  stripe_connect_client_id?: string
  stripe_connect_details_submitted?: boolean
  stripe_connect_charges_enabled?: boolean
  next_payroll_date?: string
  auto_deductions?: boolean
  next_invoice_date?: string
  invoice_cycle?: string
  accept_stripe?: boolean
  nhf?: boolean
  nhf_value?: number
  nhis?: string
  letter_head?: string
  letter_head_media?: File
  attach_invoice_items?: boolean
}
export type OnboardingSettingsModel = {
  id?: string
  name: string
  type: string
  setting_id?: string
  status?: boolean
}
export type AdditionalFieldsModel = {
  id?: string
  name: string
  type: string
  status?: boolean
}
